import React, { useState } from "react";
import { Modal } from "react-bootstrap";

export default function ReUploadOrgModal({ show, onHide, onSave }) {
  const [inputValue, setInputValue] = useState({
    message: ""
  });

  const handleChange = e => {
    const { name, value } = e.target;

    setInputValue(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <>
      <Modal
        size="md"
        show={show}
        centered
        onHide={onHide}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <h4>Lengkapi Dokumen Lembaga</h4>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col">
              <label>Pesan</label>
              <input
                name="message"
                className="form form-control"
                placeholder="cth: Harap lengkapi dokumen lembaga..."
                value={inputValue.message}
                onChange={handleChange}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary float-right" onClick={onHide}>
            Batal
          </button>
          <button
            className="btn btn-primary float-right"
            onClick={() => onSave(inputValue)}
          >
            Simpan
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
